export function VideoBanner() {
    return <div className="lg:py-20 m-2">
        <iframe width="100%" height="400" src="https://www.youtube.com/embed/-rigf7UngN0"
                title="YouTube video player" frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen/>
    </div>
}
